import React from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const currentLang = i18n.language;
  
  return (
    <div className="flex items-center justify-center gap-2 p-4">
      <FiGlobe className="w-4 h-4 text-navy-400" />
      <div className="join join-horizontal rounded-full">
        <button 
          onClick={() => changeLanguage("es")}
          className={`join-item btn btn-sm rounded-full px-3 font-medium transition-all ${
            currentLang === 'es' 
              ? 'btn-primary shadow-md' 
              : 'btn-ghost hover:bg-navy-100 text-navy-500'
          }`}
        >
          ES
        </button>
        <button 
          onClick={() => changeLanguage("en")}
          className={`join-item btn btn-sm rounded-full px-3 font-medium transition-all ${
            currentLang === 'en' 
              ? 'btn-primary shadow-md' 
              : 'btn-ghost hover:bg-navy-100 text-navy-500'
          }`}
        >
          EN
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;